<template>
  <div class="audit-sidebar page__sidebar h-100">
    <div class="sr-side-bar ap-sidebar">
      <div class="ap-sidebar__header">
        <b-row class="py-2 w-100 m-0">
          <b-col
            cols="auto"
            class="d-flex menu-main-title pl-3 pr-0"
            style="line-height:1rem;"
          >
            <div class="align-self-center">
              <div>
                <span
                  class="ap-sidebar__title font-weight--medium m-0"
                >
                  {{ $t('audit.sidebar.auditTitle') }}
                </span>
              </div>
            </div>
          </b-col>
          <b-col class="d-flex align-items-center justify-content-end pr-2">
            <div
              v-testing="'icon'"
              class="icon-wrapper-main white"
            >
              <i
                class="fal fa-ballot-check mr-2"
                aria-hidden="true"
              />
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="scroll-sidebar">
        <div class="section-header p-2 text-center main">
          <b-col>{{ $t('audit.sidebar.searchCriteria') }}</b-col>
        </div>
        <div class="search-block px-3 mt-2">
          <div>
            <span class="criterion filter-label-sidebar"><i
              class="far fa-calendar mr-1"
              aria-hidden="true"
            />{{ $t('audit.sidebar.date') }}</span>
          </div>
          <div>
            <vt-combo-select
              ref="timeSelector"
              v-model="selectedTime"
              v-testing="'time-selector'"
              class="multiselect--sidebar"
              track-by="value"
              :options="OPTIONS_TIME_ARRAY"
              label="text"
              :allow-empty="false"
            />
          </div>
          <div>
            <span class="label filter-label-sidebar">{{ $t('audit.sidebar.startDate') }}</span>
            <vt-date-picker
              v-testing="'start-date'"
              :class="{ 'requiredField': showErrors && !startDate }"
              class="input--sidebar"
              type="date"
              :not-after="endDate"
              :model="startDate"
              @update="setStartDate"
              @clear="startDate = null"
            />
          </div>
          <div>
            <span class="label filter-label-sidebar">{{ $t('audit.sidebar.endDate') }}</span>
            <vt-date-picker
              v-testing="'end-date'"
              :class="{ 'requiredField': showErrors && !endDate }"
              class="input--sidebar"
              type="date"
              :not-before="startDate"
              :model="endDate"
              @update="setEndDate"
              @clear="endDate = null"
            />
          </div>
        </div>
        <div class="search-block px-3 mt-3">
          <div>
            <span class="criterion filter-label-sidebar"><i
              class="far fa-user mr-1"
              aria-hidden="true"
            />{{ $t('audit.sidebar.user') }}</span>
          </div>
          <div>
            <vt-combo-select
              v-model="selectedUser"
              v-testing="'user'"
              class="multiselect--sidebar"
              track-by="id"
              :option-loader="searchUsers"
              ajax-search
              label="label"
              :internal-search="false"
            />
          </div>
        </div>
        <div class="multiselection search-block px-3 mt-3">
          <div>
            <span class="criterion filter-label-sidebar"><i
              class="far fa-laptop mr-1"
              aria-hidden="true"
            />{{ $t('audit.sidebar.actions') }}</span>
          </div>
          <div>
            <vt-combo-select
              v-model="selectedActionTypes"
              v-testing="'action-types'"
              class="multiselect--sidebar"
              :option-loader="loadActionTypes"
              track-by="id"
              label="name"
              :multiple="true"
            />
          </div>
        </div>
        <div class="search-block px-3 mt-3">
          <div>
            <span class="criterion filter-label-sidebar"><i
              class="far fa-list-ul mr-1"
              aria-hidden="true"
            />{{ $t('audit.sidebar.entities') }}</span>
          </div>
          <div>
            <audit-entities-multiselect :ref="entityFilterName + '0'" />
            <!--      TODO: This mock piece of code is for having multiple OR conditions. This is currently not supported by backend, so until then it is commented
          <div class="d-flex justify-content-start mt-1">-->
            <!--        <a type="button" class="linkbtn" @click="newEntity"><i class="far fa-plus-circle mr-1" aria-hidden="true"></i>{{$t('audit.sidebar.addAnother')}}</a>-->
            <!--      </div>-->
          </div>
        </div>
        <!--    TODO: This mock piece of code is for having multiple OR conditions. This is currently not supported by backend, so until then it is commented
        <div v-for="i in entityFilters" :key="'dyn-element-' + i" class="search-block px-3 mt-3">-->
        <!--      <div>-->
        <!--        <hr>-->
        <!--      </div>-->
        <!--      <div>-->
        <!--        <vt-combo-select v-model="selectedElements2" track-by="value"-->
        <!--          :options="optionsElements2" label="text"/>-->
        <!--        <div class="multiselection">-->
        <!--        <vt-combo-select-->
        <!--            class="mt-2"-->
        <!--            v-model="selectedExamples"-->
        <!--            track-by="value"-->
        <!--            :options="optionsExamples"-->
        <!--            label="text"-->
        <!--            :multiple="true"-->
        <!--            v-validate="'required'"-->
        <!--          />-->
        <!--      </div>-->
        <!--      <div class="d-flex justify-content-start mt-1">-->
        <!--        <a type="button" class="linkbtn-red" @click="removeEntityFilter(i)"><i class="far fa-minus-circle mr-1" aria-hidden="true"></i>{{$t('audit.sidebar.delete')}}</a>-->
        <!--      </div>-->
        <!--      </div>-->
        <!--    </div>-->
        <div class="px-3 mt-3 footer-buttons">
          <b-row>
            <b-col class="pr-1">
              <b-button
                v-testing="'clear'"
                v-shortkey="['ctrl', 'del']"
                size="sm"
                class="btn__outline btn__outline--light"
                block
                @shortkey.prevent="loadDefaultValues"
                @click="loadDefaultValues"
              >
                {{ $t('audit.sidebar.clear') }}
              </b-button>
            </b-col>
            <b-col class="pl-1">
              <b-button
                v-testing="'search'"
                v-shortkey="['ctrl', 'enter']"
                size="sm"
                class="btn--primary"
                block
                @shortkey.prevent="search"
                @click="search"
              >
                {{ $t('audit.sidebar.search') }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import auditedActionService from '@/modules/auditModule/services/AuditedActionService'
import commonUserServices from '@/api/resources/common/commonUserServices'
import AuditEntitiesMultiselect from '@/modules/auditModule/views/components/AuditEntitiesMultiselect'
import i18n from '@/lang/i18n'
import { GridUtils } from '@/shared/util/grid-utils'

export const OPTIONS_TIME = {
    TODAY: { value: 'TODAY', text: i18n.t('audit.sidebar.today') },
    LAST_WEEK: { value: 'LAST_WEEK', text: i18n.t('audit.sidebar.lastWeek') },
    LAST_MONTH: { value: 'LAST_MONTH', text: i18n.t('audit.sidebar.lastMonth') },
    LAST_YEAR: { value: 'LAST_YEAR', text: i18n.t('audit.sidebar.lastYear') },
    CUSTOM_DATE: { value: 'CUSTOM_DATE', text: i18n.t('audit.sidebar.customDate') }
}

export default {
    name: 'AuditSideBar',
    components: { AuditEntitiesMultiselect },
    data() {
        return {
            showErrors: false,
            entityFilters: [],
            selectedTime: null,
            startDate: null,
            endDate: null,
            selectedUser: null,
            selectedElements2: '',
            optionsElements2: [
                { value: 'a', text: this.$tc('audit.elements.patient', 2) },
                { value: 'b', text: this.$tc('audit.elements.case', 2) },
                { value: 'c', text: this.$tc('audit.elements.sample', 2) },
                { value: 'd', text: this.$tc('audit.elements.portion', 2) },
                { value: 'e', text: this.$tc('audit.elements.subportion', 2) },
                { value: 'f', text: this.$tc('audit.elements.request', 2) },
                { value: 'g', text: this.$tc('audit.elements.user', 2) },
                { value: 'h', text: this.$tc('audit.elements.incident', 2) },
                { value: 'i', text: this.$tc('audit.elements.complementary', 2) }
            ],
            selectedActionTypes: null,
            selectedExamples: null,
            optionsExamples: [
                { value: 'a', text: 'Opción 1' },
                { value: 'b', text: 'Opción 2' },
                { value: 'c', text: 'Opción 3' }
            ]
        }
    },
    computed: {
        OPTIONS_TIME_ARRAY() {
            return Object.values(OPTIONS_TIME)
        },
        entityFilterName() {
            return 'entityFilter-'
        }
    },
    watch: {
        selectedTime(newTime) {
            const dateSelected = OPTIONS_TIME[newTime.value]
            switch (dateSelected) {
            case OPTIONS_TIME.TODAY:
                this.endDate = moment()
                this.startDate = moment()
                break
            case OPTIONS_TIME.LAST_WEEK:
                this.endDate = moment()
                this.startDate = moment().subtract(1, 'week')
                break
            case OPTIONS_TIME.LAST_MONTH:
                this.endDate = moment()
                this.startDate = moment().subtract(1, 'month')
                break
            case OPTIONS_TIME.LAST_YEAR:
                this.endDate = moment()
                this.startDate = moment().subtract(1, 'year')
                break
            default:
                break
            }
        }
    },
    mounted() {
        this.loadDefaultValues()
        this.$nextTick(() => this.search())
    },
    methods: {
        newEntity() {
            this.entityFilters.push(this.entityFilters.length + 1)
        },
        removeEntityFilter(entityFilterToDelete) {
            for (let i = 0; i < this.entityFilters.length; i++) {
                if (this.entityFilters[i] === entityFilterToDelete) {
                    this.entityFilters.splice(i, 1)
                }
            }
        },
        setStartDate(date) {
            this.selectedTime = OPTIONS_TIME.CUSTOM_DATE
            this.startDate = moment(date)
        },
        setEndDate(date) {
            this.selectedTime = OPTIONS_TIME.CUSTOM_DATE
            this.endDate = moment(date)
        },
        loadDefaultValues() {
            this.selectedTime = OPTIONS_TIME.TODAY
            this.selectedUser = null
            this.selectedActionTypes = null
            this.$refs[this.entityFilterName + '0'].clear()
        },
        validateDateRangeFilter(startDate, endDate) {
            let valid = true
            if (!startDate || !endDate) {
                valid = false
            }
            return valid
        },
        search() {
            if (!this.validateDateRangeFilter(this.startDate, this.endDate)) {
                this.showErrors = true
            } else {
                this.showErrors = false
                const filterModel = this.generateFilterModel()
                this.$eventHub.$emit('updatedFilterModelForAuditGrid', filterModel)
            }
            if (this.showErrors) {
                this.showErrorModalGlobal(this.$t('studyRequest.general.requiredFieldsNotice'))
            }
        },
        generateFilterModel() {
            const filterModel = {
                timestamp: GridUtils.getDateFilterModel('inRange', this.startDate, this.endDate)
            }
            if (this.selectedUser) {
                filterModel['user.id'] =
                    GridUtils.getNumberFilterModel('equals', this.selectedUser.id)
            }
            if (this.selectedActionTypes && this.selectedActionTypes.length > 0) {
                filterModel['entityActionType'] =
                    GridUtils.getSetFilterModel(this.selectedActionTypes.map(actionType => actionType.id))
            }

            const entityMultiselect = this.$refs[this.entityFilterName + '0']
            if (entityMultiselect.selectedEntityTypes && entityMultiselect.selectedEntityTypes.length > 0) {
                filterModel['entityClassName'] =
                    GridUtils.getSetFilterModel(entityMultiselect.selectedEntityTypes.map(entityType => entityType.id))

                if (entityMultiselect.selectedEntities && entityMultiselect.selectedEntities.length > 0) {
                    filterModel['entityId'] =
                        GridUtils.getSetFilterModel(entityMultiselect.selectedEntities.map(elem => elem.id))
                } else if (entityMultiselect.multiEntitySearchQuery) {
                    filterModel['entityLabel'] =
                        GridUtils.getTextFilterModel('contains', entityMultiselect.multiEntitySearchQuery)
                }
            }
            return filterModel
        },
        async searchUsers(query) {
            if (query) {
                return commonUserServices.search({
                    query,
                    size: 10
                })
            }
            return []
        },
        async loadActionTypes() {
            return auditedActionService.findAllActionTypesSorted()
        }
    }
}

</script>

<style lang="scss">
.audit-sidebar .requiredField {
    border: 1px solid red;
}

.audit-sidebar .mx-calendar .cell.disabled {
    background-color: transparent;
}

.audit-sidebar .mx-input-append svg {
    background: transparent;
}

.audit-sidebar .link-label {
  font-weight: normal;
}

.audit-sidebar .multiselection .multiselect__tags {
  line-height: 1.3 !important;
  height: auto !important;
}

.audit-sidebar .multiselection .multiselect__input, .multiselect__single{
  margin-bottom: 0 !important;
  line-height: 1.3 !important;
  min-height: 18.5px !important;
}

.audit-sidebar .mx-datepicker-popup{
  left: -16px !important;
}

.audit-sidebar .multiselect__tags {
  opacity: 1;
  background: vt-color(sidebar-section-header-bg);
  border: 0;
  color: vt-color(sidebar-section-header-text);
}

.audit-sidebar .multiselect__input {
  background: transparent !important;
  color: vt-color(sidebar-section-header-text);
}

.audit-sidebar .multiselect__select:before {
  border-color: vt-color(sidebar-section-header-text, .3) transparent transparent;
}

.audit-sidebar .multiselect__select {
    right: -5px;
}

.audit-sidebar .mx-datepicker .mx-input {
  background-color: vt-color(sidebar-section-header-bg);
  border: 0;
  color: vt-color(sidebar-section-header-text);
}

.audit-sidebar input,
.audit-sidebar input:focus {
    background-color: vt-color(sidebar-section-header-bg);
    color: vt-color(sidebar-section-header-text);
    border: 0;
}

.audit-sidebar .mx-calendar-icon,
.audit-sidebar .mx-clear-icon{
  color: vt-color(sidebar-section-header-text, .3);
}

.audit-sidebar .btn__outline {
  border-color: vt-color(white-light);
  color: vt-color(white-light);
}

.audit-sidebar .btn__outline:hover {
  border-color: vt-color(primary);
}

.audit-sidebar .multiselect__content-wrapper {
    background: vt-color(sidebar-childs-bg) !important;
    border: 0;
}

.audit-sidebar .multiselect__option {
    color: vt-color(sidebar-child-font);
}

.audit-sidebar .multiselect__option--highlight,
.audit-sidebar .multiselect__option--selected {
    background: vt-color(sidebar-single-element-hover);
    font-weight: normal;
}

.audit-sidebar .multiselect__spinner {
    background: transparent;
    top: -2px;
}

.audit-sidebar .multiselect__spinner:after,
.audit-sidebar .multiselect__spinner:before {
    border-top-color: vt-color(sidebar-child-font);
}

.audit-sidebar .multiselect--active .multiselect__input::placeholder {
    color: #adadad !important;
}

.audit-sidebar .mx-datepicker-popup {
    background-color: vt-color(sidebar-childs-bg);
}

.audit-sidebar .mx-calendar {
    color: vt-color(sidebar-child-font);
}

.audit-sidebar .next-month,
.audit-sidebar .last-month {
    color: vt-color(sidebar-child-font, .8) !important;
}

.audit-sidebar .mx-calendar-content .cell:hover,
.audit-sidebar .mx-calendar-content .cell.actived {
    background-color: vt-color(sidebar-single-element-hover);
}
</style>

<style scoped lang="scss">

.scroll-sidebar{
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.footer-buttons{
  padding: 10px;
  position: sticky;
  bottom: 0;
}

.vt-date-picker{
  padding: 0 !important;
}

.criterion {
  text-transform: uppercase;
  font-size: font-size(very-tiny);
}

.label{
  font-size: font-size(tiny);
}

.section-header{
  text-transform: uppercase;
  font-size:0.9rem;
  background: vt-color(sidebar-section-header-bg);
  color: vt-color(sidebar-section-header-text);
}

.sr-side-bar{
-webkit-box-shadow: 1px 0 5px 0 rgba(179,179,179,1);
-moz-box-shadow: 1px 0 5px 0 rgba(179,179,179,1);
box-shadow: 1px 0 5px 0 rgba(179,179,179,1);
}

$sideBarBorder: 1px solid #d8d8d8;

.menu-main-title{
  line-height: 0.9rem;
}

.menu-module{
  display: flex;
  align-items: center;
}

.section-pd{
  padding-bottom: 0.5rem;
  width:100%;
  margin:0;
}

.icon-wrapper-main{
  font-size:1.6rem;
}

.sr-side-bar {
  display: flex;
  flex-direction: column;
  width: 245px;
  height: 100%;
  min-height: 0;
}

@media (max-width: 1300px){

  .section-header{
    font-size:0.8rem;
  }

  .icon-wrapper{
    font-size: 1.1rem;
  }

  .menu-main-title h4{
    font-size:1rem;
  }

  .menu-main-title{
    line-height: 0.9rem;
  }

  .icon-wrapper-main{
  font-size:1.4rem;
}

}

</style>
